export const themeColors = {
  'Brand Strong': {
    background: 'bg-brand-strongest',
    text: 'text-brand-base color-brand-base'
  },
  'Brand Subtle': {
    background: 'bg-[#DFF6F0]',
    text: 'text-brand-strongest color-brand-strongest'
  },
  'Grape Strong': {
    background: 'bg-accent1-strongest',
    text: 'text-accent1-base color-accent1-base'
  },
  'Grape Subtle': {
    background: 'bg-[#EBECFF]',
    text: 'text-accent1-strongest color-accent1-strongest'
  },
  'Lagoon Strong': {
    background: 'bg-[#00364D]',
    text: 'text-accent2-base color-accent2-base'
  },
  'Lagoon Subtle': {
    background: 'bg-[#DFF5FF]',
    text: 'text-accent2-strongest color-accent2-strongest'
  },
  'Lime Strong': {
    background: 'bg-accent3-strongest',
    text: 'text-accent3-base color-accent3-base'
  },
  'Lime Subtle': {
    background: 'bg-[#F0F5C1]',
    text: 'text-accent3-strongest color-accent3-strongest'
  },
  'Piggybank Strong': {
    background: 'bg-[#581226]',
    text: 'text-accent5-base color-accent5-base'
  },
  'Piggybank Subtle': {
    background: 'bg-[#FFE8F1]',
    text: 'text-accent5-strongest color-accent5-strongest'
  },
  'Tangerine Strong': {
    background: 'bg-accent4-strongest',
    text: 'text-accent4-base color-accent4-base'
  },
  'Tangerine Subtle': {
    background: 'bg-[#FFF1DD]',
    text: 'text-accent4-strongest color-accent4-strongest'
  }
};
